

export default function PiratePost() {
    return (
        <div>
            Inspired by the VeggieTales song <a href="https://www.youtube.com/watch?v=XaWU1CmrJNc">The Pirates who Don't Do Anything</a>, I've created a quiz to determine if you are a Pirate who Doesn't Do Anything.
            <br />
            <br />
            <a href="/#/pirates" style={{fontWeight: 'bold'}}>Take the Quiz!</a>
        </div>
    )
}

export function PirateDevNotes() {
    return (
        <div>
            Shortly after I learned how to create a website and got timhays.online up and running, I realized I gotta get posting quickly if I want to get the most out of my domain name before it expires in a year.
            <br />
            <br />
            Around the same time, I contracted a brain worm that insisted it would be the funniest thing in the world if I took the lyrics to this silly song from my childhood and turned each line into a quiz-style question. And so I quickly got to work on the Lazy Pirate Quiz and shipped this site's first showcase project.
            <br />
            <br />
            Admittedly, the UI design and legibility is not great. I was inspired by the internet of the 90s where website styling leaned way harder into unique, thematic designs at the cost of cohesion. Or in other words, I was lazy and didn't want to think too hard about what looks good together.
        </div>
    )
}